import * as tslib_1 from "tslib";
import { RemoveScroll } from 'react-remove-scroll/UI';
export { AutoFocusInside, MoveFocusInside, InFocusGuard } from 'react-focus-lock/UI';
export var classNames = tslib_1.__assign({}, RemoveScroll.classNames);
